// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_Aom","cls2":"ClaimEvaluationRow-cls2_qlf ClaimEvaluationRow-cls1_Aom","shimmer":"ClaimEvaluationRow-shimmer_YcU"};